<template>
  <div class="content-block">

    <PrivacyPolicyLink>
    </PrivacyPolicyLink>

    <footer class="footer">
      <div><img class="logo" src="../assets/CSL-Logo-Small-300x225.png"/></div>
      <div class="copyright"> CSL Software Solutions, Inc. © 2020</div>
    </footer>
  </div>
</template>

<script>
  import {DxButton} from 'devextreme-vue';
  import PrivacyPolicyLink from "../components/privacy-policy-link";

  export default {
    components:{
      DxButton,
      PrivacyPolicyLink,
    },
    methods:{
        btnPrivacyPolicyClick(e){
            console.log("btnPrivacyPolicyClick");
            
        }
    }
  }
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";



.footer {
  display: flex;
  color: rgba($base-text-color, alpha($base-text-color) * 0.7);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 20px;
  padding-bottom: 24px;
  text-align:center;

  margin:auto;
  justify-content: center;
}

.logo{
  height: 70px;
}

.copyright{
  padding-top:30px;
  font-size:10px;
}
</style>
